﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadDynamicDrawingDimensionField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadDynamicDrawingDimensionField, eOutputFieldType.cadDynamicDrawingDimension)
export class CadDynamicDrawingDimensionField extends OutputField implements ICadDynamicDrawingDimensionField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public visible: boolean;
    public point1Name: string;
    public point1ParentId: string;
    public point2Name: string;
    public point2ParentId: string;
    public x: number;
    public y: number;
    public vertical: boolean;
    public viewFullName: string;
}
